var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center-center"},[(_vm.src)?_c('img',{staticClass:"img-style-item",class:_vm.animation ? 'list-img' : '',attrs:{"src":_vm.src,"alt":_vm.alt,"onerror":_vm.errorPlaceholder}}):_c('img',{staticClass:"img-style-item fail-max-wh",attrs:{"src":_vm.failPlaceholder,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }